import { AST } from '@handlebars/parser';
import { createBlockStatement } from 'modules/handlebars/domain/statement/utils';
import { createProgram } from 'modules/handlebars/domain/program';

import type { ConditionalContent } from '../../domain';
import { createInverseFromConditionalContent } from './createInverseFromConditionalContent';
import { createBlockStatementConfigFromConditionalContent } from './createBlockStatementConfigFromConditionalContent';

export const createProgramFromConditionalContent = (
  conditionalContent: ConditionalContent,
): AST.Program => {
  const config = createBlockStatementConfigFromConditionalContent(conditionalContent);
  const inverse = createInverseFromConditionalContent(conditionalContent);

  const blockStatement = [createBlockStatement({ ...config, inverse })];
  return createProgram({ body: blockStatement });
};
